import { useCallback, useEffect } from 'react';
import { getCustomizeCampaign } from '../../services/campaign';

const NEW_MEMBER_OPEN = 'NEW_MEMBER_OPEN';

export const useNMFDDRumView = ({
  init,
  isEditOpen,
  customizePage = null,
  datadogRum,
}: {
  init: boolean;
  isEditOpen: boolean;
  customizePage?: typeof NEW_MEMBER_OPEN | 'NEW_MEMBER_OPEN_SOON' | null;
  datadogRum: { startView: (viewName: string) => void };
}) => {
  const getIsNMCustomizeOpen = useCallback(async () => {
    if (customizePage) {
      return customizePage === NEW_MEMBER_OPEN;
    } else {
      const data = await getCustomizeCampaign({
        newMember: true,
      });

      return (
        (data as { userInfo: { customizePage: string } }).userInfo.customizePage === NEW_MEMBER_OPEN
      );
    }
  }, [customizePage]);

  useEffect(() => {
    if (!init) {
      return;
    }
    (async () => {
      const isNMCustomizeOpen = await getIsNMCustomizeOpen();

      if (isNMCustomizeOpen && isEditOpen) {
        datadogRum.startView('NMF - Boosts');
      } else if (isNMCustomizeOpen && !isEditOpen) {
        datadogRum.startView('NMF - No Boosts');
      } else if (!isNMCustomizeOpen) {
        datadogRum.startView('NMF - Closed Customize');
      }
    })();
  }, [init, isEditOpen, datadogRum, getIsNMCustomizeOpen]);
};
